import React from "react";

export interface SetupChecklistItem {
  id: string;
  label: string;
  hint?: string;
}

/**
 * Work the CA does outside Zournal (in Zoho, mostly), as a numbered list of
 * reference points — here is the route, in order — with nothing to tick and
 * nothing gated. These used to be tickable gates on Continue; that was
 * dropped everywhere on purpose: the items mostly happen later (or in Zoho
 * where we can't see them), so a tick was a claim, not a check.
 *
 * Numbered rather than bulleted because these lists are sequences: exporting
 * masters before the new organisation exists is doing the work twice.
 */
export function SetupChecklist({
  title = "Things to do",
  items,
}: {
  title?: string;
  items: SetupChecklistItem[];
}) {
  return (
    <div className="flex flex-col rounded-lg border">
      <div className="border-b px-4 py-3">
        <span className="text-sm font-semibold">{title}</span>
      </div>
      <ol className="flex flex-col gap-1 p-3">
        {items.map((item, index) => (
          <li key={item.id} className="flex w-full items-start gap-3 rounded-md p-2 text-left">
            <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full border border-border text-[11px] font-semibold text-muted-foreground">
              {index + 1}
            </span>
            <span className="flex flex-col gap-0.5">
              <span className="text-sm font-medium">{item.label}</span>
              {item.hint && <span className="text-xs text-muted-foreground">{item.hint}</span>}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
